<template>
  <div>
    <template v-if="authUser.id">
      <template v-if="authUser.is_employee">
        <v-btn
          v-if="applicationExists"
          class="white--text ma-0"
          :to="{ name: 'employee.application' }"
          :color="buttonColor"
          :block="block"
        >
          {{ $t('texts.toTheActiveApplications') }}
          <v-icon right class="white--text">email</v-icon>
        </v-btn>
        <v-btn
          v-else
          class="white--text ma-0"
          :to="{ name: 'employee.application.edit', params: { job } }"
          :color="buttonColor"
          :block="block"
        >
          {{ $t('texts.apply') }}
          <v-icon right class="white--text">email</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          class="white--text ma-0"
          @click="showOnlyForEmployeesDialog()"
          :color="buttonColor"
          :block="block"
        >
          {{ $t('texts.apply') }}
          <v-icon right class="white--text">email</v-icon>
        </v-btn>
      </template>
    </template>
    <template v-else>
      <v-btn
        class="white--text ma-0"
        @click="showRegistrationRequiredDialog()"
        :color="buttonColor"
        :block="block"
      >
        {{ $t('texts.apply') }}
        <v-icon right class="white--text">email</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState } = createNamespacedHelpers('user');
const { mapState: mapEmployeeState } = createNamespacedHelpers('employee');

export default {
  name: 'ApplicationButton',
  props: {
    block: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      job: {},
    };
  },
  created() {
    if (this.$route.params.job) {
      Object.assign(this.job, { ...this.$route.params.job, company: this.$route.params.company.name });
    }
  },
  computed: {
    ...mapUserState([
      'authUser',
    ]),
    ...mapEmployeeState([
      'jobApplications',
    ]),
    applicationExists() {
      return this.jobApplications.all.find((item) => parseFloat(item.job_id) === parseFloat(this.job.id));
    },
    buttonColor() {
      return this.light ? 'white' : 'primary';
    },
  },
  methods: {
    showRegistrationRequiredDialog() {
      this.$eventBus.$emit('show-user-registration-required-dialog');
    },
    showOnlyForEmployeesDialog() {
      this.$eventBus.$emit('show-only-for-employee-dialog');
    },
  },
};
</script>
